/*
 * @Author: your name
 * @Date: 2020-09-24 13:19:16
 * @LastEditTime: 2020-12-03 17:23:25
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \qh-wbactive\src\page\marketact\services\index.js
 */
import http from '@http';
import apis from './apis';

const axios = http();

export default class SystemService {
    // 公众号黄历
    static gettodaydaigram(params) {
        return axios.get(apis.gettodaydaigram, params);
    }
    // 公众号每日图片
    static getDailyCoverUrl(params) {
        return axios.get(apis.getDailyCoverUrl, params);
    }
}
